export const FETCH_RADIOLOGIST_ALL_DDLIST_REQUEST = 'FETCH_RADIOLOGIST_ALL_DDLIST_REQUEST';
export const FETCH_RADIOLOGIST_ALL_DDLIST_SUCCESS = 'FETCH_RADIOLOGIST_ALL_DDLIST_SUCCESS';
export const FETCH_RADIOLOGIST_ALL_DDLIST_FAILURE = 'FETCH_RADIOLOGIST_ALL_DDLIST_FAILURE';

export const EXPORT_AUDIT_LOGS_REQUEST = 'EXPORT_AUDIT_LOGS_REQUEST';
export const EXPORT_AUDIT_LOGS_SUCCESS = 'EXPORT_AUDIT_LOGS_SUCCESS';
export const EXPORT_AUDIT_LOGS_FAILURE = 'EXPORT_AUDIT_LOGS_FAILURE';

export const GetAllModuleFieldActionTypeDropdown_REQUEST = 'GetAllModuleFieldActionTypeDropdown_REQUEST';
export const GetAllModuleFieldActionTypeDropdown_SUCCESS = 'GetAllModuleFieldActionTypeDropdown_SUCCESS';   
export const GetAllModuleFieldActionTypeDropdown_FAILURE = 'GetAllModuleFieldActionTypeDropdown_FAILURE';

export const GetAllAuditLogsList_REQUEST = 'GetAllAuditLogsList_REQUEST';
export const GetAllAuditLogsList_SUCCESS = 'GetAllAuditLogsList_SUCCESS';
export const GetAllAuditLogsList_FAILURE = 'GetAllAuditLogsList_FAILURE';

export const GETALLAUDITLOGCUSTOMREPORT_REQUEST = 'GETALLAUDITLOGCUSTOMREPORT_REQUEST';
export const GETALLAUDITLOGCUSTOMREPORT_SUCCESS = 'GETALLAUDITLOGCUSTOMREPORT_SUCCESS';
export const GETALLAUDITLOGCUSTOMREPORT_FAILURE = 'GETALLAUDITLOGCUSTOMREPORT_FAILURE';

export const EXPORTAUDITLOGCUSTOMREPORT_REQUEST = 'EXPORTAUDITLOGCUSTOMREPORT_REQUEST';
export const EXPORTAUDITLOGCUSTOMREPORT_SUCCESS = 'EXPORTAUDITLOGCUSTOMREPORT_SUCCESS';
export const EXPORTAUDITLOGCUSTOMREPORT_FAILURE = 'EXPORTAUDITLOGCUSTOMREPORT_FAILURE';